import React, { useState } from 'react';
import { useLarguraTela } from '../hooks/useLarguraTela';

const S = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    background: '#f4f7fb',
    padding: 16,
  },
  card: {
    background: '#ffffff',
    borderRadius: 16,
    padding: '44px 40px',
    width: '100%',
    maxWidth: 380,
    boxShadow: '0 18px 45px rgba(15, 23, 42, 0.08)',
    border: '1px solid #dbe4ef',
  },
  logo: {
    textAlign: 'center',
    marginBottom: 36,
  },
  logoTitle: {
    color: '#0f172a',
    fontSize: 22,
    fontWeight: 700,
    letterSpacing: '-0.3px',
  },
  logoSub: {
    color: '#64748b',
    fontSize: 13,
    marginTop: 5,
  },
  label: {
    color: '#334155',
    fontSize: 13,
    fontWeight: 500,
    marginBottom: 6,
    display: 'block',
  },
  input: {
    width: '100%',
    padding: '10px 14px',
    background: '#ffffff',
    border: '1px solid #cbd5e1',
    borderRadius: 8,
    color: '#0f172a',
    fontSize: 14,
    marginBottom: 20,
    outline: 'none',
  },
  button: {
    width: '100%',
    padding: '12px',
    background: '#3b82f6',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    fontSize: 15,
    fontWeight: 600,
    cursor: 'pointer',
  },
  error: {
    background: '#fef2f2',
    border: '1px solid #fecaca',
    color: '#b91c1c',
    padding: '10px 14px',
    borderRadius: 8,
    fontSize: 13,
    marginBottom: 20,
  },
};

export default function Login({ onLogin }) {
  const larguraTela = useLarguraTela();
  const ehMobile = larguraTela <= 900;
  const [login, setLogin] = useState('');
  const [senha, setSenha] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ login, senha }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Erro ao fazer login'); return; }
      onLogin(data.token, data.usuario);
    } catch {
      setError('Erro de conexão com o servidor');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={S.container}>
      <form style={{ ...S.card, padding: ehMobile ?'28px 18px' : S.card.padding }} onSubmit={handleSubmit}>
        <div style={S.logo}>
          <div style={S.logoTitle}>CD HeadThink</div>
          <div style={S.logoSub}>Deploy Dashboard</div>
        </div>

        {error && <div style={S.error}>{error}</div>}

        <label style={S.label}>Login</label>
        <input
          style={S.input}
          type="text"
          value={login}
          onChange={(e) => setLogin(e.target.value)}
          placeholder="admin"
          autoFocus
        />

        <label style={S.label}>Senha</label>
        <input
          style={S.input}
          type="password"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          placeholder="⬢⬢⬢⬢⬢⬢⬢⬢"
        />

        <button style={{ ...S.button, opacity: loading ?0.7 : 1 }} type="submit" disabled={loading}>
          {loading ?'Entrando...' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}

